var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3711 12.8813C14.1906 13.0883 13.9891 13.2758 13.75 13.4145V14.3105C16.3484 14.6754 18.125 15.4062 18.125 16.25C18.125 17.4582 14.4875 18.4375 10 18.4375C5.5125 18.4375 1.875 17.4582 1.875 16.25C1.875 15.4062 3.65156 14.6758 6.25 14.3105V13.4145C6.01094 13.2758 5.80938 13.0883 5.62891 12.8813C2.29961 13.4898 0 14.7676 0 16.25C0 18.3211 4.47734 20 10 20C15.5227 20 20 18.3211 20 16.25C20 14.7676 17.7004 13.4898 14.3711 12.8813ZM10 5C11.3809 5 12.5 3.88086 12.5 2.5C12.5 1.11914 11.3809 0 10 0C8.61914 0 7.5 1.11914 7.5 2.5C7.5 3.88086 8.61914 5 10 5ZM7.5 12.5V16.25C7.5 16.9402 8.05977 17.5 8.75 17.5H11.25C11.9402 17.5 12.5 16.9402 12.5 16.25V12.5C13.1902 12.5 13.75 11.9402 13.75 11.25V7.5C13.75 6.46445 12.9105 5.625 11.875 5.625H11.4141C10.9816 5.82148 10.5055 5.9375 10 5.9375C9.49453 5.9375 9.01836 5.82148 8.58594 5.625H8.125C7.08945 5.625 6.25 6.46445 6.25 7.5V11.25C6.25 11.9402 6.80977 12.5 7.5 12.5Z",
    fill: "#414651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google-maps.f688205f6f2df08b99f70aca06153b7d.svg";
export { ForwardRef as ReactComponent };